import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
    component: () => import("@/layout"),
    children: [
      {
        //用户管理
        path: "/userManage",
        name: "userManage",
        component: () => import("../views/userManage/userManage"),
      },
      {
        //司机管理
        path: "/driverManage",
        name: "driverManage",
        component: () => import("../views/userManage/driverManage"),
      },
      {
        //时刻表管理
        path: "/timetableManage",
        name: "timetableManage",
        component: () => import("../views/timetableManage/timetableManage"),
      },
      {
        //时刻表管理
        path: "/slideshowManage",
        name: "slideshowManage",
        component: () => import("../views/slideshowManage/slideshowManage"),
      },
      {
        //车票数管理
        path: "/ticketNumberManage",
        name: "ticketNumberManage",
        component: () => import("../views/ticketManage/ticketNumberManage"),
      },
      {
        //车票价格管理
        path: "/ticketPriceManage",
        name: "ticketPriceManage",
        component: () => import("../views/ticketManage/ticketPriceManage"),
      },
      {
        //添加地区
        path: "/addArea",
        name: "addArea",
        component: () => import("../views/areaManage/addArea"),
      },
      {
        //地区管理
        path: "/areaManage",
        name: "areaManage",
        component: () => import("../views/areaManage/areaManage"),
      },
      {
        //订单管理
        path: "/orderManage",
        name: "orderManage",
        component: () => import("../views/orderManage/orderManage"),
      },
      {
        //退款管理
        path: "/refundManage",
        name: "refundManage",
        component: () => import("../views/orderManage/refundManage"),
      }
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login"),
  }
];

const router = new VueRouter({
  mode: 'history', // 设置为 history 模式
  routes,
});

export default router;
